<template>
  <div :class="$style.container">
    <Header title="External Users" subtitle="Manage access for external users">
      <AddBulkExternalUser />
      <ManageExternalUser :updateUserCB="updateUserCB" :user="selectedUser"/>
      <Button :icon="{ left: `filter` }" @click="advanced = !advanced"
        >Advanced Query
      </Button>
    </Header>

    <template v-if="advanced">
      <vue-json-editor
        :class="$style.advancedQuery"
        v-model="filter"
        :show-btns="false"
        :expandedOnStart="true"
      ></vue-json-editor>
      <Select
        :options="sortFieldOptions"
        :class="$style.advancedQuery"
        label="Sort Field"
        name="sortField"
        v-model="sortFieldIndex"
        placeholder="Sort field"
      />
      <Select
        :options="sortCriteriaOptions"
        :class="$style.advancedQuery"
        label="Sort Criteria"
        name="sortCriteria"
        v-model="sortCriteriaIndex"
        placeholder="Sort criteria"
      />
    </template>

    <Input
      :class="$style.item"
      name="search"
      label="Search"
      placeholder="Search for user"
      v-model="text"
    />
    <template v-if="data.length > 0">
      <VirtualList
        :class="$style.list"
        :data-component="DiscordCard"
        :data-sources="data"
        :estimate-size="130"
        :extra-props="{ setSelectedUser: setSelectedUser }"
        :item-class="$style.item"
        :wrap-class="$style.wrap"
        data-key="_id"
      />
      <Button @click="loadMore">Load More</Button>

      <TextComponent align="center" as="p" type="p">
        Page: {{ page }} | Batch Size: {{ batchSize }} | Downloaded:
        {{ data.length }}
      </TextComponent>
    </template>
    <div v-else>
      <TextComponent align="center" as="h3" type="heading3"
        >No results found :(
      </TextComponent>
    </div>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Input from '@hackthe6ix/vue-ui/Input';
  import Select from '@hackthe6ix/vue-ui/Select';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import Text from '@hackthe6ix/vue-ui/Text';
  import Textarea from '@hackthe6ix/vue-ui/Textarea';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/filter';
  import vueJsonEditor from 'vue-json-editor';
  import VirtualList from 'vue-virtual-scroll-list';
  import Card from '../../../containers/Card';
  import DiscordCard from '../../../containers/DiscordCard';
  import Header from '../../../containers/Header';
  import { getObject } from '../../../utils/api';
  import AddBulkExternalUser from './AddBulkExternalUser';
  import ManageExternalUser from './ManageExternalUser';

  export default {
  name: 'ExternalUsers',
  data() {
    return {
      DiscordCard,
      data: [],
      advanced: false,
      sortCriteriaIndex: 0,
      sortCriteria: 'asc',
      sortCriteriaOptions: ['asc', 'desc'],
      sortFieldIndex: 0,
      sortField: 'created',
      sortFieldOptions: [
        'firstName',
        'lastName',
      ],
      text: '',
      page: 1,
      batchSize: 50,
      loading: true,
      selectedUser: null
    };
  },
  components: {
    AddBulkExternalUser,
    ManageExternalUser,
    DiscordCard,
    Button,
    Card,
    VirtualList,
    Select,
    Stack,
    Header,
    Input,
    Textarea,
    TextComponent: Text,
    vueJsonEditor,
  },
  methods: {
    setSelectedUser(user) {
      this.selectedUser = user;
    },
    updateUserCB(user) {
      if (user) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i]._id === user._id) {
            this.data[i] = user;
            return;
          }
        }

        this.data.push(user);
      }

      this.selectedUser = null;
    },
    async fetchQuery(reset) {
      if (reset) {
        this.page = 1;
      }

      const result = await getObject('externaluser', {
        sortCriteria: this.sortCriteria,
        sortField: this.sortField,
        filter: this.filter,
        text: this.text.length ? this.text : undefined,
        size: this.batchSize,
        page: this.page,
      });

      if (result.success) {
        this.loading = false;
        this.data = reset ? result.data : [...this.data, ...result.data];
      } else {
        swal('Error', result.data, 'error');
      }
    },
    loadMore() {
      this.page++;
      this.fetchQuery();
    },
    update() {
      try {
        this.fetchQuery(true);
      } catch (e) {
        alert(`Invalid Query! ${e}`);
      }
    },
  },
  beforeMount() {
    this.fetchQuery(true);
  },
  watch: {
    text(t) {
      this.fetchQuery(true);
    },
    filter(f) {
      this.fetchQuery(true);
    },
    sortCriteriaIndex(i) {
      this.sortCriteria = this.sortCriteriaOptions[i];
      this.fetchQuery(true);
    },
    sortFieldIndex(i) {
      this.sortField = this.sortFieldOptions[i];
      this.fetchQuery(true);
    },
  },
};
</script>

<style lang="scss" module src="./ExternalUsers.module.scss" />
